import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
  typography: {
    fontFamily: '"proxima-nova", sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1200,
    },
  },
  palette: {
    primary1Color: "#282857",
    primary2Color: "#616161",
    primary3Color: "#78909C",
    accent1Color: "#18FFFF",
    accent2Color: "#84FFFF",
    accent3Color: "#FFFFFF",
    textColor: "#000000",
    alternateTextColor: "#FFFFFF",
    canvasColor: "#FAFAFA",
    borderColor: "#E0E0E0",
    disabledColor: "#0000004D",
    pickerHeaderColor: "#78909C",
    clockCircleColor: "#00000012",
    shadowColor: "#000000",
  },
});
